<template>
  <div>
    <!-- 移动端 -->
    <div v-if="isPC === false && $route.path !== '/pod-designer' && $route.path !== '/ai-designer' && $route.path !== '/login' && $route.path !== '/register'" class="mobile-layout">
      <index-header></index-header>
      <keep-alive>
        <router-view v-if="$route.meta.isKeep"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.isKeep"></router-view>
      <Footer v-if="!hiddenFooter($route.path)" />
    </div>
    <!-- PC端 -->
    <div v-else class="layout">
      <index-header v-if="!hiddenHeader($route.path)" />
      <div :style="{ paddingTop: hiddenHeader($route.path) ? 0 : '80px'}">
        <keep-alive>
          <router-view v-if="$route.meta.isKeep"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.isKeep"></router-view>
        <!-- <router-view /> -->
      </div>
      <Footer v-if="!hiddenFooter($route.path)" />
    </div>
  </div>
</template>

<script>
// import Header from '../mobile/Header.vue'
import Header1 from '@/views/home/components/HomeHead.vue'
import Footer from '@/views/home/components/BlackFooter'
// import API from '@/api'

export default {
  data() {
    return {
      isScroll: false,
      hiddenFooterRouteList: [
        '/customizedAdd',
        '/customizedSuccess',
        '/certificate',
        '/certificate-submiited',
        '/blog',
        '/login',
        '/register',
        '/ai-designer',
        '/pod-designer'
      ],
      hiddenHeaderRouteList: [
        '/login',
        '/register',
        '/ai-designer',
        '/pod-designer'
      ]
    }
  },
  components: {
    // Header,
    'index-header': Header1,
    Footer
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    hiddenHeader(path) {
      if (path.charAt(path.length - 1) === '/') {
        path = path.substring(0, path.length - 1)
      }
      return this.hiddenHeaderRouteList.includes(path)
      // let hidden = false
      // this.hiddenHeaderRouteList.forEach(item => {
      //   if (path.includes(item)) hidden = true
      // })
      // return hidden
    },
    hiddenFooter(path) {
      if (path.charAt(path.length - 1) === '/') {
        path = path.substring(0, path.length - 1)
      }
      return this.hiddenFooterRouteList.includes(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  font-family: 'Poppins', 'PingFang SC', 'Sen', 'Helvetica', 'Arial', 'Sans-serif';
}

// 移动端
.mobile-layout {
  padding-top: 0.86rem;
}
</style>
